import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { SafeUrl, Title } from '@angular/platform-browser';
import { Storage } from '@ionic/storage';
import { IonVirtualScroll, ModalController } from '@ionic/angular';
import { WelcomePopupComponent } from '../../shared/components/welcome-popup/welcome-popup.component';
import { BackendService } from '../../core/services/backend-prod.service';
import { HelperService } from '../../core/services/helper.service';
import { Router } from '@angular/router';
import { VendorBackendService } from 'src/app/core/services/vendor-services/vendor-backend.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardPage implements OnInit {

  breadcrumbList: any = [
    {
      label: 'Dashboard',
      url: '/vendor/baseapp/dashboard'
    }
  ];
  recentViews: any;
  UpdateViews: any;
  profileName: string;
  profileImageId;
  profileImagePath: SafeUrl = "../../assets/images/profile-avatar.svg";

  @ViewChild(IonVirtualScroll, { static: false }) virtualScroll;

  organizationId;
  roleId;
  page_min = 0;
  page_max = 7;
  from_date: string = "";
  to_date: string = "";

  constructor(
    private title: Title,
    private backendService: VendorBackendService,
    public modalController: ModalController,
    public storage: Storage,
    public helperService: HelperService,
    private router: Router
  ) { }


  ngOnInit() {
    // this.openWelcomePopup();
    this.title.setTitle('eZintegrations | Dashboard');
    this.getStorage().then((res: any) => {
      //console.log("res", res);
      this.profileName = res.firstName + ' ' + res.lastName;
      this.getProfileDetails(res);
      let payload = {
        id: res.userId,
        min: this.page_min,
        max: this.page_max,
        fromDate: this.from_date,
        toDate: this.to_date,
      }
      // let decoded_token = JSON.parse(atob(res.token.split('.')[1]))
      // this.roleId = decoded_token.role.role_id;
      this.roleId = res.role_id;
      if (this.roleId == 1) {
        this.backendService.PostAPICall('getAllUsersActivity', payload, res.token).subscribe(
          data => { this.recentViews = data }
        );
      } else if (this.roleId == 2) {
        this.backendService.PostAPICall('getOrgUsersActivity', payload, res.token).subscribe(
          data => { this.recentViews = data }
        );
      }else{
        //console.log("else part")
      }
     
      this.backendService.GetAPICall('getViews', res.token).subscribe(
        data => {
          let UpdateViews = data.data;
          for (let data of UpdateViews) {
            data.description = data.description;
          }
          this.UpdateViews = UpdateViews;
        });
    });



    // this.backendService.Get('getUpdatesList').subscribe(
    //   data => { this.UpdateViews = data, //console.log(this.UpdateViews) }
    // );
  }

  getProfileDetails(_storage) {
    // this.getStorage().then((storageVal) => {
      this.organizationId = _storage.userId;
      let payload = {
        id: _storage.userId
      }
      //console.log(payload);
      this.backendService.PostAPICall('getProfileInfo', payload, _storage.token).subscribe(
        (response) => {
          let res = response;
          
          this.storage.set('job_title', res.job_title);
          let obj = {};
            obj = {
              firstName: _storage.firstName,
              lastName: _storage.lastName,
              jobTitle: res.jobTitle,
              token: _storage.token,
              profileImageId: res.profile_image_id
            }
          this.helperService.dataFromStorage(obj);

          this.roleId = _storage.role_id;
          this.profileImageId = res.profile_image_id;
          if (this.profileImageId != null) {
            this.getProfileImage(this.profileImageId, _storage);
          }
        },
        (error) => {
          //console.log(error);
        }
      );
    // })
  }

  getProfileImage(image_id, _storage) {
    let payload = {
      "img_collection_id": image_id
    }
    let method = 'post';//getUserProfileImage
    this.backendService.fileUpload('getProfileImage', method, payload, _storage.token).subscribe(
      (data: any) => {
        this.profileImagePath = 'data:image/jpg;base64,' + data.profileImage_hash;
      },
      (error) => {
        //console.log(error);
        // this.helperService.presentToast(error.error.detail, 3000);
      }
    )
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      firstName: await this.storage.get("first_name"),
      lastName: await this.storage.get("last_name"),
      profile_image_id: await this.storage.get("profile_image_id"),
      role_id: await this.storage.get("role_id"),
      jobTitle: await this.storage.get("job_title")
    }
    return data;
  }

  navigate() {
    window.open("https://support.bizdata360.com/", '_blank').focus();
  }


  async openWelcomePopup() {
    const modal = await this.modalController.create({
      component: WelcomePopupComponent,
      cssClass: 'welcome',
      // componentProps: {
      //   'model_title': "Welcome Popup"
      // }
    });

    return await modal.present();
  }
}

